import ApplicationController from './application_controller'
import autocomplete from 'autocompleter'

export default class extends ApplicationController {

	static targets = [
		'input',
	]

	static values = {
		emptyMessage:  { type: String, default: 'No Matches Found' },
		preloadedData: { type: Array, default: [] }, // this is an array of objects with these keys: { label: '', value: '' }
		matchLimit:    { type: Number, default: 8 },
	}

	connect() {
		this.autocomplete = autocomplete({
			input: this.inputTarget,
			fetch: this.fetch.bind(this),
			onSelect: this.select.bind(this),
			emptyMsg: this.emptyMessageValue,
			minLength: 1,
			debounceWaitMs: 0,
			showOnFocus: true,
		})
	}

	fetch(text, update) {
		text = text.toLowerCase();

		if (this.preloadedDataValue.length > 0) {
			const suggestions = this.preloadedDataValue.filter(item => item.label.toLowerCase().indexOf(text) >= 0)
			update(suggestions.slice(0,this.matchLimitValue))
		} else {
			console.log('No autocomplete suggestions provided.')
		}
	}

	select(item) {
		this.inputTarget.value = item.value
	}

}
